export const NAMESPACE = "UISelectFields";

export const SEARCH_BAR_INSTANCE_ID = "UISelectFieldsSearchBar";
